import React from 'react';

export const Person: React.FC<{color: string}> = ({color}) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <circle cx="10" cy="4.286" r="4.286" fill={color} />
    <path d="M20 20H0C0 14.4772 4.47715 10 10 10C15.5228 10 20 14.4772 20 20Z" fill={color} />
  </svg>
);
